import axios from 'axios';
import apiLogger from './apiLogger';
import { showAppError } from '../services/messageDialogService';
import { clearAuthSession } from '../storage/authStorage';

export const axios_adapter = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axios_adapter.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('token');
    const idToken = localStorage.getItem('idToken');
    const tokenToUse = accessToken || idToken;
    const guestIdentityId = localStorage.getItem('guestIdentityId');

    if (tokenToUse) {
      config.headers.Authorization = `Bearer ${tokenToUse}`;
    } else if (guestIdentityId && !config.headers['x-identity-id']) {
      config.headers['x-identity-id'] = guestIdentityId;
    }

    return apiLogger.request(config);
  },
  (error) => apiLogger.error(error)
);

axios_adapter.interceptors.response.use(
  (response) => apiLogger.response(response),
  (error) => {
    const isNetworkError =
      !error?.response &&
      (error?.message === 'Network Error' || error?.code === 'ERR_NETWORK');

    if (isNetworkError) {
      showAppError('Network error detected. Please check CORS or API availability.');
    } else if (error?.response?.status === 401) {
      clearAuthSession();
      showAppError('Session expired. Please login again.');
      if (typeof window !== 'undefined' && window.location.pathname !== '/') {
        window.location.replace('/');
      }
    }

    return apiLogger.error(error);
  }
);
